import React, { useState, useRef } from 'react';

function Notification() {
  const notificationText = "Warm reminder: Please contact customer service through the platform customer service button every time. Don't trust anyone outside the platform who claims to be customer service.";
  const [isExpanded, setIsExpanded] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [hasMoved, setHasMoved] = useState(false);
  const bannerRef = useRef(null);

  const handleStart = (clientX) => {
    setStartX(clientX);
    setIsDragging(true);
    setHasMoved(false);
  };

  const handleMove = (clientX) => {
    if (!isDragging) return;
    const diff = clientX - startX;
    if (Math.abs(diff) > 5) {
      setHasMoved(true);
    }
    setCurrentX(diff);
  };

  const handleEnd = () => {
    if (hasMoved) {
      if (currentX > 80) {
        setIsExpanded(true);
      } else if (currentX < -80) {
        setIsExpanded(false);
      }
    }
    setCurrentX(0);
    setIsDragging(false);
    setHasMoved(false);
  };

  const handleTouchStart = (e) => {
    handleStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    handleMove(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    handleEnd();
  };

  const handleMouseDown = (e) => {
    handleStart(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      handleMove(e.clientX);
    }
  };

  const handleMouseUp = () => {
    if (isDragging) {
      handleEnd();
    }
  };

  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging]);

  const handleClick = (e) => {
    // Only toggle if user didn't drag
    if (!hasMoved && !isDragging) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="container-fluid px-3 py-3">
      <div 
        className={`notification-banner ${isExpanded ? 'expanded' : ''}`}
        ref={bannerRef}
        onClick={handleClick}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
      >
        <div className="d-flex align-items-center">
          <div className="notification-icon-container me-3">
            <i className="bi bi-bell-fill"></i>
          </div>
          <div className="notification-content-wrapper">
            {!isExpanded ? (
              <div className="notification-marquee">
                <span className="notification-text">{notificationText}</span>
                <span className="notification-text">{notificationText}</span>
              </div>
            ) : (
              <div className="notification-expanded-content">
                <div className="notification-expanded-text">
                  {notificationText}
                </div>
              </div>
            )}
          </div>
          {!isExpanded && (
            <div className="notification-swipe-indicator">
              <i className="bi bi-chevron-right"></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Notification;

